import React from "react";
import styled from "styled-components";
import { DatePicker } from "antd";

const FormDatePicker = ({ children, ...props }) => {
  return (
    <DatePicker
      {...props}
      placeholder="YYYY-MM-DD"
      size="large"
      style={{
        border: "1px solid var(--aia-bx-gray-5)",
        borderRadius: 100,
        padding: "8px 16px",
        height: 48,
        width: "100%",
        outlineColor: "var(--aia-bx-blue-2)",
        "&:hover, &:focus": {
          boxShadow: "0px 0px 0.5rem 0px rgba(2, 114, 174, 0.2)",
        },
      }} />
  );
};

export default FormDatePicker;